export async function ptlSentUseCase(shipping_service, shipmentRepository) {

    const result = await shipmentRepository.ptl_get_sent_orders(shipping_service);
    
    result.forEach(x => {
        
        x.created_at = x.created_at.split("T")[0];
        x = new shipmentRepository.model_ptl_index(x);

        if (!x.isValid()) {
            throw new Error("Shipment ptl inválido");
        }
    })

    return result;
}